import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BriefcaseIcon, DollarSignIcon, BoxesIcon, MonitorIcon, GraduationCapIcon, CheckIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { CTASection } from '../components/CTASection';
import { DemoModal } from '../components/DemoModal';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { solutionCategories } from '../data/solutions';
const iconMap = {
  briefcase: BriefcaseIcon,
  dollar: DollarSignIcon,
  boxes: BoxesIcon,
  monitor: MonitorIcon,
  graduation: GraduationCapIcon
};
export function SolutionsPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  return <motion.main initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.4
  }} className="min-h-screen w-full bg-stark-white overflow-x-hidden" data-id="element-427" data-mp="2jmgwymkmtt30">
      <Header onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-428" data-mp="30610cqbm24wo" />

      <PageHero eyebrow="Solutions" title="Consulting, financial discipline, operations, and technology." description="Every engagement is built from the same five capabilities — combined to match where your business is today and where it needs to go." data-id="element-429" data-mp="305iud1z5ccbk" />

      <section className="py-24 md:py-32" data-id="element-430" data-mp="3f2jhes6e7j3p">
        <div className="max-w-7xl mx-auto px-6 space-y-6" data-id="element-431" data-mp="2hfjcp05mxzi6">
          {solutionCategories.map((category, idx) => {
          const Icon = iconMap[category.icon as keyof typeof iconMap];
          return <motion.article key={category.title} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.06,
            ease: 'easeOut'
          }} className="group grid lg:grid-cols-3 gap-10 p-8 md:p-12 bg-stark-white border border-midnight-navy/10 rounded-2xl hover:border-royal-blue/40 hover:shadow-xl hover:shadow-midnight-navy/5 transition-all" data-id="element-432" data-mp="2rcxfhwymyps0" data-mpi={idx}>
                <div className="space-y-6" data-id="element-433" data-mp="20ef8duk39ykd">
                  <div className="w-14 h-14 rounded-2xl bg-royal-blue/10 text-royal-blue flex items-center justify-center group-hover:bg-royal-blue group-hover:text-stark-white transition-colors" data-id="element-434" data-mp="1coced8wm6ij4">
                    <Icon className="w-7 h-7" data-id="element-435" data-mp="1mmifhoaljkmx" />
                  </div>
                  <h2 className="text-midnight-navy text-2xl md:text-3xl font-montserrat font-extrabold leading-tight" data-id="element-436" data-mp="1mkfigkb10r8p">
                    {category.title}
                  </h2>
                  <p className="text-midnight-navy/60 leading-relaxed" data-id="element-437" data-mp="2y045fboa5q9i">
                    {category.description}
                  </p>
                </div>

                <div className="lg:col-span-2 lg:border-l lg:border-midnight-navy/10 lg:pl-12" data-id="element-438" data-mp="30lkbcjmvb91z">
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-439" data-mp="35kwtws6phtyr">
                    {category.services.map(service => <li key={service} className="flex items-center gap-3 text-midnight-navy font-medium" data-id="element-440" data-mp="2rmqh2zx0eurl">
                        <span className="w-6 h-6 rounded-full bg-cool-gray text-royal-blue flex items-center justify-center shrink-0" data-id="element-441" data-mp="3jcbh7b7nchbm">
                          <CheckIcon className="w-3.5 h-3.5" data-id="element-442" data-mp="3oawgn8f2qwz0" />
                        </span>
                        {service}
                      </li>)}
                  </ul>
                </div>
              </motion.article>;
        })}
        </div>
      </section>

      <CTASection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-443" data-mp="64ry5ckmdmdp" />
      <Footer data-id="element-444" data-mp="ax1lqly9iact" />
      <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} data-id="element-445" data-mp="axl0jtsm8imm" />
    </motion.main>;
}